export default "__VITE_ASSET__1YhoOU7h__"